export default "__VITE_ASSET__1ae9ed89__"